import styled, { css } from 'styled-components';

import { Stack, TableCell, Typography } from 'components';

export const Wrapper = styled(Stack)`
  flex-grow: 1;
  min-height: 0;
`;

export const HeaderWrapper = styled(Stack)`
  align-items: center;
  justify-content: flex-start;
  margin-top: 2rem;
`;

export const Header = styled(Typography)`
  color: ${props => props.theme.custom.palette.secondary500};
  margin-right: 1.6rem;
`;

export const TableCounter = styled(Typography)`
  font-weight: 600;
  font-size: 1.6rem;
  height: 2.4rem;
`;

export const TableCellText = styled(Typography)`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.5;
  color: ${props => props.theme.custom.palette.gray};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledTableBodyCell = styled(TableCell)<{
  height: string;
  cellstyles: string;
}>`
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 0;
  border-bottom: 1px solid ${props => props.theme.custom.palette.truegray300};
  height: ${props => props.height};
  padding: 0 1.6rem;
  &:not(:last-child):after {
    position: absolute;
    top: 1rem;
    right: 0;
    bottom: 0;
    border-right: 1px solid ${props => props.theme.custom.palette.truegray300};
    width: 1px;
    content: '';
  }
  ${props => props.cellstyles};
`;

export const ActionButtonsCellStyles = css`
  padding: 0 0.8rem;
`;
export const StyledTableColumnLabel = styled(Typography)`
  font-weight: 900;
  font-size: 2rem;
  text-transform: uppercase;
  color: ${props => props.theme.custom.palette.primary900};
`;

export const EmptyState = styled(Typography)`
  font-size: 1.6rem;
  font-weight: 600;
  margin-top: 3.6rem;
`;

export const LoadingContainer = styled(Stack)`
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const tableComponents = {
  TableBodyCell: StyledTableBodyCell,
  TableColumnLabel: StyledTableColumnLabel,
};
